import { useRouter } from '@tanstack/react-router';
import { ConnectorRouteView, JourneysConnectorHandoff, useConnectorHandoffHrefs } from '@/features/integrations';
import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import MParticleConnectorPage from './index.page';

/** The two spellings of this connector's URL. */
function useHandoffHrefs() {
  const router = useRouter();
  return useConnectorHandoffHrefs({
    buildMigrated: (workspaceId) =>
      router.buildLocation({ to: '/workspaces/$workspaceId/integrations/mparticle_out', params: { workspaceId } }).href,
    buildLegacy: (workspaceId) =>
      router.buildLocation({
        to: '/workspaces/$workspaceId/journeys/integrations/mparticle_out',
        params: { workspaceId },
      }).href,
  });
}

/** The old `/journeys/integrations/mparticle_out` URL. */
export function JourneysMParticleHandoff() {
  const isMigrated = useFeatureFlag(AccountFeatureFlag.IntegrationConnectorsMigration);
  const { migrated } = useHandoffHrefs();

  return <JourneysConnectorHandoff isMigrated={isMigrated} migratedHref={migrated} />;
}

/**
 * The migrated `/integrations/mparticle_out` URL.
 *
 * `ConnectorRouteView` applies the gates Ember's `integrations` root route applied. This page's own
 * route added no further permission gate — the mParticle permission gates the controls, not the
 * page — so nothing nests inside it here.
 */
export function MParticleConnectorRouteView() {
  const isMigrated = useFeatureFlag(AccountFeatureFlag.IntegrationConnectorsMigration);
  const { legacy } = useHandoffHrefs();

  return (
    <ConnectorRouteView isMigrated={isMigrated} legacyHref={legacy}>
      {(workspaceId) => <MParticleConnectorPage workspaceId={workspaceId} />}
    </ConnectorRouteView>
  );
}
